<template>
	<vx-card class="pb-5">
		<vs-popup
			:active.sync="showRefreshDataVerifyPopup"
			title="Relancer l'analyse"
		>
			<div class="space-y-20 text-center">
				<h4>
					Souhaitez-vous relancer le chargement de toutes les données (les
					données collectées seront perdues) ?
				</h4>
				<div class="text-right space-x-4">
					<vs-button @click="refreshData" ref="prospectRefreshButtonRef"
						>Oui</vs-button
					>
					<vs-button color="danger" @click="showRefreshDataVerifyPopup = false"
						>Abandonner</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<div class="flex w-full">
			<div class="w-1/3 flex">
				<div>
					<div>
						<p>Nom de la recherche</p>
						<h3>{{ $props.detail.name }}</h3>
						<br />
						<div class="">
							<div
								v-if="$props.detail.progressCompleted != 100"
								class="flex items-center"
							>
								<vs-progress
									class="w-2/3"
									:height="8"
									:percent="$props.detail.progressCompleted"
									color="success"
									>success</vs-progress
								>
								&nbsp;&nbsp;
								{{ $props.detail.progressCompleted }} %
							</div>
							<div v-else class="flex items-center">
								<div>Complété</div>
								&nbsp;&nbsp;
								<vs-icon icon="check_circle" color="success"></vs-icon>
							</div>
						</div>
					</div>
				</div>
				<div class="flex ml-5 items-center">
					<vx-tooltip text="Relancer l'analyse" position="top">
						<vs-button
							size="large"
							color="primary"
							type="flat"
							icon-pack="feather"
							icon="icon-download-cloud"
							@click="onClickRefresh()"
						></vs-button>
					</vx-tooltip>

					<vx-tooltip text="Modifier" position="top">
						<vs-button
							size="large"
							color="primary"
							type="flat"
							icon-pack="feather"
							icon="icon-edit"
							@click="editProspect()"
						></vs-button>
					</vx-tooltip>
				</div>
			</div>

			<div class="divider"></div>
			<!-- Vertical Divider -->
			<div class="flex flex-row justify-between px-4 w-2/3">
				<!-- Apply vertical spacing -->

				<div>
					<p>Domaine d'activité</p>
					<h3 class="text-center">{{ $props.detail.domain_activity }}</h3>
				</div>

				<div>
					<p>Localisation</p>
					<h3 class="text-center">{{ $props.detail.country }}</h3>
				</div>
				<div>
					<p>Langue</p>
					<h3 class="text-center">{{ $props.detail.language }}</h3>
				</div>
				<div>
					<p>Nombre de Keywords</p>
					<h3 class="text-center">{{ $props.detail.keywords_count }}</h3>
				</div>
				<div>
					<p>Nombre de Prospects</p>
					<h3 class="text-center">{{ $props.detail.prospects_count }}</h3>
				</div>
				<div>
					<p>Moteur de recherche</p>
					<h3 class="text-center">{{ $props.detail.search_engine }}</h3>
				</div>
				<div>
					<p>Date de création</p>
					<h3 class="text-center">
						{{ getDateToFrenchFormat($props.detail.creation_date) }}
					</h3>
				</div>

				<div>
					<p>Createur</p>
					<!-- {{ $props.detail.user_id }} -->
					<div class="vx-row center-content">
						<vx-tooltip
							:text="getCollaboratorName($props.detail.user_id)"
							position="top"
						>
							<vs-avatar
								style="border: 1px solid"
								badge=""
								badge-color="rgb(140, 23, 164)"
								:text="getCollaboratorName($props.detail.user_id)"
								:src="getCollaboratorAvatar($props.detail.user_id)"
							/>
						</vx-tooltip>
					</div>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
import store from "@/store/store";
import VxCard from "../../../widgets/vx-card/VxCard.vue";
export default {
	components: { VxCard },
	name: "ProspectionDetailsCard",
	props: {
		detail: {
			// competitors.length
			type: Object,
			default: null,
		},
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	data() {
		return {
			showRefreshDataVerifyPopup: false,
			// Your data properties go here
		};
	},
	computed: {
		// Your computed properties go here
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	created() {
		// Code to run when the component is created
		this.getAllCollaborators();
		this.getAllCollaboratorsAvatar();
	},
	methods: {
		editProspect() {
			this.$router.push({
				name: "update_entity",
				params: { psId: this.$props.detail.id, updateEntityForm: "prospect" },
			});
		},
		onClickRefresh() {
			this.showRefreshDataVerifyPopup = true;
		},
		refreshData() {
			this.setLoading(true, "prospectRefreshButtonRef");
			this.$http
				.get(`/prospect/project/refresh/${this.$props.detail.id}`)
				.then((_) => {
					this.showRefreshDataVerifyPopup = false;
					this.setLoading(false, "prospectRefreshButtonRef");
					this.$vs.notify({
						title: "Rafraichissement",
						text: "La recherche a été rafraichie",
						color: "success",
					});
				})
				.catch((err) => {
					this.setLoading(false, "prospectRefreshButtonRef");
					console.log("Error: refreshData", err);
					this.$vs.notify({
						title: "Rafraichissement",
						text: "Erreur lors du rafraichissement",
						color: "danger",
					});
				});
		},
		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},
		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(avatar) => avatar.id == userId
			);
			if (foundCollaborator)
				return `${foundCollaborator.firstname} ${foundCollaborator.lastname}`;
			else return null;
		},
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},
		// Your methods go here
	},
	mounted() {
		// Code to run when the component is mounted
	},

	destroyed() {
		// Code to run when the component is destroyed
	},
};
</script>

<style scoped>
.divider {
	border-left: 1px solid black; /* Adjust the style of your divider */
	height: 100%; /* Adjust the height of the divider */
}
/* Your component styles go here */
</style>
